import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import MoreOptionsIcon from 'dibs-icons/exports/MoreOptions';
import classNames from 'classnames';

import styles from './styles.scss';

type Props = {
    localizedPdpUrl: string;
    hasTopMargin?: boolean;
};

export const MoreOptionsBadge: FunctionComponent<Props> = ({ localizedPdpUrl, hasTopMargin }) => {
    return (
        <div className={classNames(styles.container, { [styles.hasTopMargin]: hasTopMargin })}>
            <a href={localizedPdpUrl} className={styles.link}>
                <MoreOptionsIcon className={styles.moreOptionsIcon} />
                <FormattedMessage
                    id="dc.searchProductTile.moreOptionsBadge"
                    defaultMessage="More Options"
                />
            </a>
        </div>
    );
};
